<div
    class="relative rounded-xl px-6 py-4 space-y-3 border border-line cursor-pointer transition-all hover:shadow"
    [routerLink]="['/','address',userInfo.wallet_address]"
>
    <div class="flex-start-center gap-x-2">
        <app-hexagon-img [imgUrl]="userInfo.profile_image || commonService.getAddressIcon(userInfo.wallet_address)" class="w-[56px]"></app-hexagon-img>
        <div>
            <div class="text-base font-semibold mb-1.5">
                <ng-container *ngIf="userInfo.display_name || userInfo.ens_name; else onlyAddr"> {{commonService.getAddrName(userInfo)}} </ng-container>
                <ng-template #onlyAddr>{{commonService.getAddrName(userInfo) | address}}</ng-template>
            </div>

            <div class="flex-start-center gap-x-2">
                <div
                    class="w-fit flex-start-center gap-x-1 py-1.5 px-2 rounded-[4px] bg-[#f7f7f7]"
                    appCopy
                    [copyText]="userInfo.wallet_address"
                    (click)="$event.stopPropagation()"
                >
                    <div class="text-sm leading-[1]">{{userInfo.wallet_address | address}}</div>
                    <span nz-icon nzType="antd:v2-copy" class="text-base"></span>
                </div>

                <a
                    *ngIf="userInfo.twitter_username"
                    class="w-fit flex-center-center p-1.5 px-2 rounded-[4px] bg-[#f7f7f7]"
                    target="_blank"
                    href="https://x.com/{{userInfo.twitter_username}}"
                >
                    <span nz-icon nzType="antd:x" class="text-sm"></span>
                </a>
            </div>
        </div>
    </div>

    <div class="flex-start-center gap-x-2 mt-2 h-6">
        <span class="text-xs text-[#999999]">
            <span class="font-normal text-black">{{(userInfo.followers_count || 0)|kmb2:2}} </span>
            <ng-container *ngIf="userInfo.followers_count>1">Followers</ng-container>
            <ng-container *ngIf="userInfo.followers_count<=1">Follower</ng-container>
        </span>

        <div *ngIf="userInfo.badges?.length" class="divider-vertical mx-3 h-3"></div>

        <div class="flex-start-center gap-x-1 flex-1">
            <img *ngFor="let item of userInfo.badges | slice:0:4" [src]="item.icon_enabled" [alt]="item.name" class="w-6 h-6" [nz-tooltip]="item.name" />
            <span *ngIf="userInfo.badges?.length > 4" class="text-xs text-[#999999]">+{{userInfo.badges?.length - 3}}</span>
        </div>
    </div>

    <app-follow-btn [followedWalletAddressInfo]="userInfo"></app-follow-btn>
</div>
